"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleDisableScrollbar = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const styleDisableScrollbar = exports.styleDisableScrollbar = {
  className: 'base-ui-disable-scrollbar',
  element: /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
    href: "base-ui-disable-scrollbar",
    precedence: "base-ui:low",
    children: `.base-ui-disable-scrollbar{scrollbar-width:none}.base-ui-disable-scrollbar::-webkit-scrollbar{display:none}`
  })
};